import React from 'react';

import HasData from '../../../validate/HasData';

const HasEnrichmentQuestion = props => {
    const {eventId, questionId, to, children} = props;

    return <HasData to={to} check={state => state.events[eventId]?.enrichments.questions?.find(q => q.id == questionId)}>{children}</HasData>;
};

export default HasEnrichmentQuestion;
